export function getExercisesFromLocal() {
  let data = null;
  if (typeof window !== 'undefined') {
    data = localStorage.getItem('exercises-v4');
    data = JSON.parse(data);
  }
  return data ?? [];
}

export function getExercisesByChallenge(challengeId: string) {
  const data = getExercisesFromLocal();
  if (Array.isArray(data)) {
    return data.filter((item) => item.challengeId === challengeId);
  }
  return [];
}

export function getExerciseFromLocal(exerciseId: string) {
  const data = getExercisesFromLocal();
  if (Array.isArray(data)) {
    return data.find((item) => item.exerciseId === exerciseId);
  }
  return null;
}

export function saveExerciseInLocal(data: {
  files: Record<string, any>;
  challengeId: string;
  exerciseId: string;
}) {
  const exercises = getExercisesFromLocal();
  if (Array.isArray(exercises)) {
    const exerciseIndex = exercises.findIndex((item) => item.exerciseId === data.exerciseId);
    if (exerciseIndex !== -1) {
      exercises[exerciseIndex] = data;
    } else {
      exercises.push(data);
    }
    if (typeof window !== 'undefined') {
      localStorage.setItem('exercises-v4', JSON.stringify(exercises));
    }
  }
}

export function getCountExercisesByChallenge(challengeId: string) {
  const exercises = getExercisesByChallenge(challengeId);
  return exercises.length;
}
